var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title"},[_c('div',{staticClass:"section-kicker"},[_vm._v(_vm._s(_vm.kicker))]),_c('h2',{staticClass:"section-heading"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"section-copy mb-0"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }